import React, { useRef, useState } from "react";
import { Overlay, Popover } from "react-bootstrap";
import { Copy } from "react-bootstrap-icons";
import { toast } from "react-toastify";

// Keeps the popover open while the cursor travels from the truncated text to
// the popover itself (there's a real gap between the two elements), closing
// only once the cursor leaves both for longer than this delay.
const HOVER_CLOSE_DELAY_MS = 150;

const CopyableCellText = ({ value }) => {
  const [show, setShow] = useState(false);
  const target = useRef(null);
  const closeTimer = useRef(null);

  if (!value) {
    return <span style={{ position: "absolute", left: "58px", top: "18px" }}>—</span>;
  }

  const cancelClose = () => {
    if (closeTimer.current) {
      clearTimeout(closeTimer.current);
      closeTimer.current = null;
    }
  };

  const scheduleClose = () => {
    cancelClose();
    closeTimer.current = setTimeout(() => setShow(false), HOVER_CLOSE_DELAY_MS);
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(value);
    toast.success("Copied to clipboard");
  };

  return (
    <div style={{ position: "relative", display: "inline-block", maxWidth: "100%" }}>
      <span
        ref={target}
        className="truncate-cell-text"
        onMouseEnter={() => {
          cancelClose();
          setShow(true);
        }}
        onMouseLeave={scheduleClose}
      >
        {value}
      </span>
      <Overlay target={target.current} show={show} placement="top">
        <Popover id="copyable-cell-popover" onMouseEnter={cancelClose} onMouseLeave={scheduleClose}>
          <Popover.Body
            style={{ display: "flex", alignItems: "center", gap: "8px", wordBreak: "break-word" }}
          >
            <span>{value}</span>
            <Copy
              role="button"
              title="Copy"
              style={{ cursor: "pointer", flexShrink: 0 }}
              onClick={handleCopy}
            />
          </Popover.Body>
        </Popover>
      </Overlay>
    </div>
  );
};

export default CopyableCellText;
